import { useEffect, useState } from "react";

/** mobile < 768 · tablet 768–1024 · desktop > 1024 */
export function getBreakpoint(w = typeof window !== "undefined" ? window.innerWidth : 1280) {
  return w < 768 ? "mobile" : w <= 1024 ? "tablet" : "desktop";
}

export function useBreakpoint() {
  const [bp, setBp] = useState(getBreakpoint);
  useEffect(() => {
    const onResize = () => setBp(getBreakpoint());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return bp;
}
